export const AnalyticsEvent = {
    DIGITAL_APP_SUBMISSION_CLICKED: 'cp-digital-app-submission-clicked',
    DIGITAL_APP_SUBMISSION_COMPLETE: 'cp-digital-app-submission-complete',
    DIGITAL_APP_SUBMISSION_VIEW: 'cp-digital-app-submission-view',
    DIGITAL_APP_SUBMISSION_SCREEN_ERROR_EVENT: 'cp-digital-app-submission-screen-error-event',
    DIGITAL_APP_SCHEDULE_CLICKED: 'cp-digital-app-schedule-clicked',
    PREAPPROVAL_RESULTS_VIEW: 'cp-preapproval-results-view',
    PREAPPROVAL_RESULTS_COMPLETE: 'cp-preapproval-results-complete',
    LOGIN_FORM: 'cp-login-form',
    LOGIN_FORM_SUBMITTED: 'cp-login-form-email-submitted',
    LOGIN_LINK_SUCCESS: 'cp-login-link-success',
    CONDITIONAL_BANKING_COMPLETE: 'cp-conditional-banking-complete',
    CONDITIONAL_BANKING_VIEW: 'cp-conditional-banking-view',
    SCHEDULED_CALL_SUCCESS_VIEW: 'cp-scheduled-call-success-view',
    SCHEDULED_CALL_SUCCESS_COMPLETE: 'cp-scheduled-call-success-complete',
    SCHEDULE_MEETING_SECTION_VIEW: 'cp-schedule-meeting-section-view',
    SCHEDULE_MEETING_CLICK: 'cp-schedule-meeting-click',
    SCHEDULE_ADVISOR_COMPLETE: 'cp-schedule-advisor-complete',
    CONDITIONAL_COVERAGE_VIEW: 'cp-conditional-coverage-view',
    UNDERWRITING_COMPLETE: 'cp-underwriting-complete',
    UNDERWRITING_VIEW: 'cp-underwriting-view',
    CONDITIONAL_SUCCESS: 'cp-conditional-success',
    SCHEDULE_ADVISOR_VIEW: 'cp-schedule-advisor-view',
    POLICY_RECOMMENDATION: 'cp-policy-recommendation',
    POLICY_RECOMMENDATION_COMPLETE: 'cp-policy-recommendation-complete',
    CONDITIONAL_COVERAGE_COMPLETE: 'cp-conditional-coverage-complete',
    CONDITIONAL_PAYMENT_SCHEDULE_VIEW: 'cp-conditional-payment-schedule-view',
    CONDITIONAL_PAYMENT_SCHEDULE_COMPLETE: 'cp-conditional-payment-schedule-complete',
    IDENTITY_LANDING_VIEW: 'cp-identity-landing-view',
    IDENTITY_BIRTH_STATUS_VIEW: 'cp-identity-birth-status-view',
    IDENTITY_BIRTH_STATUS_COMPLETE: 'cp-identity-birth-status-complete',
    IDENTITY_CITIZENSHIP_VIEW: 'cp-identity-citizenship-view',
    IDENTITY_CITIZENSHIP_COMPLETE: 'cp-identity-citizenship-complete',
    IDENTITY_LANDING_COMPLETE: 'cp-identity-landing-complete',
    IDENTITY_ADDRESS_VIEW: 'cp-identity-address-view',
    IDENTITY_ADVANCED_VIEW: 'cp-identity-advanced-view',
    IDENTITY_ADVANCED_COMPLETE: 'cp-identity-advanced-complete',
    IDENTITY_SUCCESS_VIEW: 'cp-identity-success-view',
    IDENTITY_SUCCESS_COMPLETE: 'cp-identity-success-complete',
    IDENTITY_SECOND_ID_VIEW: 'cp-identity-secondID-view',
    IDENTITY_SECOND_ID_COMPLETE: 'cp-identity-secondID-complete',
    /* One event for every identification path. Separate SSN, ITIN, permanent-resident and
       US-visa events meant the event that fired disclosed which document the applicant holds,
       which is a direct proxy for citizenship and immigration status — a sensitive category
       under CPRA and the Virginia, Colorado and Connecticut acts. Everyone provides some
       identification, so a single event still measures the step without revealing the answer. */
    IDENTITY_DOCUMENT_VIEW: 'cp-identity-document-view',
    IDENTITY_DOCUMENT_COMPLETE: 'cp-identity-document-complete',

    IDENTITY_ERROR_EVENT: 'cp-identity-error-event',

    WEIGHT_CHANGE_VIEW: 'cp-health-weightchange-view',
    PRIMARY_CARE_PROVIDER_YES_NO_VIEW: 'cp-health-primarycareprovideryesno-view',
    PRIMARY_CARE_PROVIDER_VIEW: 'cp-health-primarycareprovider-view',
    LAST_DOCTOR_VISIT: 'cp-health-lastdoctorvisit',

    DOCTOR_VISIT_VIEW: 'cp-health-doctorvisit-view',
    DOCTOR_VISIT_COMPLETED: 'cp-health-doctorvisit-complete',

    FATHER_STILL_LIVING_VIEW: 'cp-health-fatherstillliving-view',
    MOTHER_STILL_LIVING_VIEW: 'cp-health-motherstillliving-view',

    WEIGHT_CHANGE_COMPLETED: 'cp-health-weightchange-completed',
    PRIMARY_CARE_PROVIDER_YES_NO_COMPLETED: 'cp-health-primarycareprovideryesno-completed',
    PRIMARY_CARE_PROVIDER_COMPLETED: 'cp-health-primarycareprovider-completed',
    FATHER_STILL_LIVING_COMPLETED: 'cp-health-fatherstillliving-completed',
    MOTHER_STILL_LIVING_COMPLETED: 'cp-health-motherstillliving-completed',
    EXISTING_COVERAGE_VIEW: 'cp-existing-coverage-view',
    EXISTING_COVERAGE_COMPLETE: 'cp-existing-coverage-complete',
    PAST_APPLICATION_VIEW: 'cp-past-application-view',
    PAST_APPLICATION_COMPLETE: 'cp-past-application-complete',

    EMPLOYMENT_DETAILS_VIEW: 'cp-employment-details-view',
    EMPLOYMENT_DETAILS_COMPLETE: 'cp-employment-details-complete',
    EMPLOYMENT_DETAILS_SUBMISSION_FAILED: 'cp-employment-details-submission-failed',
    BENEFICIARIES_VIEW: 'cp-beneficiaries-view',
    BENEFICIARIES_COMPLETE: 'cp-beneficiaries-complete',
    BENEFICIARIES_ADD: 'cp-beneficiaries-add',
    BENEFICIARIES_DELETE: 'cp-beneficiaries-delete',
    BENEFICIARIES_UPDATE: 'cp-beneficiaries-update',
    MEDICAL_WRAP_UP_VIEW: 'cp-rx-main-view',
    /* One event for either answer. Separate yes/no events put the applicant's answer to a
       prescription-medication question in the event name itself. */
    MEDICAL_WRAP_UP_PRESCRIBED_ANSWERED: 'cp-rx-main-view-answered',
    MEDICAL_WRAP_INPUT_VIEW: 'cp-rx-input-view',
    /* No condition/medication/dosage events: those only fire for applicants who are on
       medication, so their existence discloses it however they are named. MEDICAL_WRAP_UP_VIEW
       and MEDICAL_WRAP_UP_COMPLETE fire for everyone and cover the step. */
    MEDICAL_WRAP_UP_COMPLETE: 'cp-rx-complete',
    GENERAL_ERROR_EVENT: 'cp-error-event',
    ERROR_NOTFOUND: 'cp-error:notfound',
    ADDITIONAL_POLICY_VIEW: 'cp-additional-policy-view',
    ADDITIONAL_POLICY_COMPLETE: 'cp-additional-policy-complete',
    FINANCIAL_SUITABILITY_VIEW: 'cp-financial-suitability-view',
    FINANCIAL_SUITABILITY_COMPLETE: 'cp-financial-suitability-complete',
    ADD_BANK_ACCOUNT_VIEW: 'cp-add-bank-account-view',
    ADD_BANK_ACCOUNT_COMPLETE: 'cp-add-bank-account-complete',
    AUTHORIZE_PAYMENT_VIEW: 'cp-authorize-payment-view',
    SIGN_POLICY_DOCUMENTS_VIEW: 'cp-sign-policy-documents-view',
    DOCUSIGN_LOADING: 'cp-docusign-loading',
    DOCUSIGN_PREPARING: 'cp-docusign-preparing',
    DOCUSIGN_DISPLAYED: 'cp-docusign-displayed',
    DOCUSIGN_SIGNING_COMPLETE: 'cp-docusign-signing-complete',
    PROSPER_FINAL_APPROVAL_VIEW: 'cp-prosper-final-approval-view',
    PROSPER_APPLICATION_QUESTIONS_VIEW: 'cp-prosper-application-questions-view',
    PROSPER_REVIEW_PAGE_MEETING_SECTION_VIEW: 'cp-prosper-review-page-meeting-section-view',
    PROSPER_HUBSPOT_MEETING_CLICK: 'cp-prosper-hubspot-meeting-click',
    PROSPER_DECISION_VIEW: 'cp-prosper-decision-view',
    PROSPER_BANKING_SUCCESS_VIEW: 'cp-prosper-banking-success-view',
    VERIFIED_RESULT: 'cp-verified-result',

    HOME_PAGE_VIEW: 'cp-inforce-home',
    APPLICATION_PAGE_VIEW: 'cp-inforce-applications',
    POLICIES_PAGE_VIEW: 'cp-inforce-policies',
    POLICIES_VIEW_DOCUMENT: 'cp-inforce-policies-view-document',
    SUPPORT_PAGE_VIEW: 'cp-inforce-support',
    SUPPORT_MESSAGE_SUBMIT: 'cp-inforce-support-message-submit',

    IUL_EXISTING_INSURANCE_VIEW: 'cp-existinginsurance-view',
    IUL_EXISTING_INSURANCE_COMPLETE: 'cp-existinginsurance-complete',
    IUL_PRIMARY_CARE_PHYSICIAN_VIEW: 'cp-primarycarephysician-view',
    IUL_PRIMARY_CARE_PHYSICIAN_COMPLETE: 'cp-primarycarephysician-complete',
    IUL_PRIMARY_CARE_PHYSICIAN_CHECKUP_VIEW: 'cp-primarycarephysician-checkup-view',
    IUL_PRIMARY_CARE_PHYSICIAN_CHECKUP_COMPLETE: 'cp-primarycarephysician-checkup-complete',
    PROSPER_PRE_DECISION_BANKING_VIEW: 'cp-prosper-pre-decision-banking-view',
} as const;

export const AnalyticsEventPrefix = {
    UNDERWRITING_RESPONSE: 'cp-underwriting',
} as const;

export type AnalyticsEvent =
    | (typeof AnalyticsEvent)[keyof typeof AnalyticsEvent]
    | `${(typeof AnalyticsEventPrefix)[keyof typeof AnalyticsEventPrefix]}-${string}`;
